import {
  Bot,
  Brain,
  FileText,
  Filter,
  GitFork,
  Play,
  UserCheck,
  Zap,
  Clock,
  CheckCircle2,
  AlertCircle,
} from 'lucide-react';
import type { FlowNodeType } from '@reflex/flows';
import { Spinner } from '@reflex/ui/components/shared/Spinner';

/** 12px tag / 14px list glyphs that match the Figma Node tag set. */
export const FLOW_NODE_TYPE_ICONS = {
  trigger: Play,
  filter: Filter,
  agent: Bot,
  agent_task: FileText,
  approval: UserCheck,
  router: GitFork,
  llm: Brain,
  action: Zap,
} as const satisfies Record<FlowNodeType, typeof Play>;

export function FlowNodeTypeIcon({ type, className }: { type: string; className?: string }) {
  const Icon = FLOW_NODE_TYPE_ICONS[type as FlowNodeType];
  if (!Icon) return null;
  return <Icon className={className ?? 'h-3.5 w-3.5'} />;
}

export function FlowNodeStatusIcon({ status }: { status: string }) {
  switch (status) {
    case 'running':
      return <Spinner size="sm" className="text-status-info" />;
    case 'waiting_approval':
      return <Clock className="h-3.5 w-3.5 text-status-warning" />;
    case 'completed':
      return <CheckCircle2 className="h-3.5 w-3.5 text-status-success" />;
    case 'error':
      return <AlertCircle className="h-3.5 w-3.5 text-status-error" />;
    default:
      return <div className="h-3.5 w-3.5 rounded-full border border-muted-foreground/30" />;
  }
}
